// Copyright (c) 2021 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';
import BatchAdmin from './batch-admin';

function BatchAdminPage () {

    return (
        <AuthenticatedPage className="atp-page batch-admin-page">
            <BatchAdmin />
        </AuthenticatedPage>
    );

}
BatchAdminPage.displayName = 'BatchAdminPage';

export default BatchAdminPage;
